import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import API from 'API';
import React, { useEffect, useState } from 'react'
import toastr from 'toastr';

export default function ChangePassword({ openModel, setOpenModel }) {
    const [form] = useForm();
    const [submitting, setSubmitting] = useState(false);
    useEffect(() => {
        if (!openModel) form.resetFields();
    },[openModel, form])
    return <Modal
        open={openModel}
        onCancel={() => setOpenModel(false)}
        title="Đổi mật khẩu"
        footer={[
            <Button loading={submitting} disabled={submitting} type='primary' key="submit" onClick={() => form.submit()}>
                Đổi mật khẩu
            </Button>,
            <Button key="close" onClick={() => setOpenModel(false)}>
                Đóng
            </Button>
        ]}
    >
        <Form
            layout='vertical'
            form={form}
            onFinish={(values) => {
                setSubmitting(true);
                API.post("/change-password/", values)
                .then(res => {
                    setOpenModel(false);
                    toastr.success("Đổi mật khẩu thành công!")
                })
                .catch(error => {
                    if (error?.response?.status === 400 && error?.response?.data?.error === "Current password is not correct") {
                        toastr.error("Mật khẩu hiện tại không chính xác!");
                        return;
                    }
                })
                .finally(() => {
                    setSubmitting(false);
                })
            }}
        >
            <Form.Item
                label="Mật khẩu hiện tại"
                name="current_password"
                rules={[
                    {
                        required: true,
                        message: "Nhập mật khẩu hiện tại!",
                    },
                ]}
            >
                <Input.Password />
            </Form.Item>
            <Form.Item
                label="Mật khẩu mới"
                name="password"
                rules={[
                    {
                        required: true,
                        message: "Nhập mật khẩu mới!",
                    },
                    {
                        validator: async (_, value) => {
                            const regex =
                                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
                            if (!value) {
                                return Promise.reject(
                                    "Nhập mật khẩu mới!"
                                );
                            }
                            if (!regex.test(value)) {
                                return Promise.reject(
                                    "Mật khẩu phải có ít nhất 1 chữ hoa, 1 chữ thường, 1 số, 1 ký tự đặc biệt và ít nhất 8 ký tự!"
                                );
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
            >
                <Input.Password />
            </Form.Item>
            <Form.Item
                label="Nhập lại mật khẩu mới"
                name="confirm-new-password"
                rules={[
                    {
                        required: true,
                        message: "Nhập lại mật khẩu mới!",
                    },
                    {
                        type: "password",
                        message:
                            "Nhập xác thực mật khẩu không đúng định dạng!",
                    },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (
                                !value ||
                                getFieldValue("password") ===
                                value
                            ) {
                                return Promise.resolve();
                            }
                            return Promise.reject(
                                new Error(
                                    "Mật khẩu mới bạn nhập không khớp!"
                                )
                            );
                        },
                    }),
                ]}
            >
                <Input.Password />
            </Form.Item>
        </Form>
    </Modal>
}